import React from 'react';
import { IconCard } from '../../../common/components/icon-card';
import { EmailLink } from '../../../common/components/link/email-link';

export const ContactUsCard = () => (
	<IconCard title="Contact Us" src="/img/envelope.svg">
		<b>Email: </b><EmailLink email="dummyapi.io@gmail.com" />
	</IconCard>
);
